import axios from "axios";
import {
  PRODUCT_URL,
  PRESIGNED_URL,
  CATEGORY_URL,
  CHATGPT_DISCRIP_URL,
  PRODUCT_CUETIP_URL,
  BULK_UPDATE_URL,
  PROMOTIONS_URL,
  MANUFACTURER_URL,
  ACTIVITY_LOGS_NEW,
  PRODUCT_LOGS_EXPORT_URL,
} from "../../../../../constants/config";
import { API_BASE_URL } from "../../../../../constants/config";
import { PRODUCT_REPORT, UPC_URL, PRODUCT_VARIANT, UPC_CHECK_URL, EXPORT_LABEL_URL, GENERATE_UPC_URL } from "../../../../../constants/config";
import { genericStatusChecker, parseFilename } from "../../../Common/utils";
import { checkBackgroundTaskStatus } from "../../../Common/backgroundTaskStatus";
import { PRODUCT_MEDIA_KEYS } from "../../../Common/constants";
import { initialFilter } from "../../pages/products/ProductsUIHelpers";

import qs from "qs";

const productMedia = {};
const basepath = API_BASE_URL;

// CREATE =>  POST: add a new product to the server
export function createProduct(product) {
  productMedia.videoData = product.video;
  productMedia.imagesData = product.images;
  product = deleteExtraEntries(product);
  return axios.post(PRODUCT_URL, product);
}

const deleteExtraEntries = (values) => {
  const valuesToDelete = [
    "brand",
    "userEnteredSku",
    "catSuggestedSku",
    "suppliers",
    "categories",
    "price",
    "tags",
    "saleable_qty",
    "video_url",
    "created_at",
    "updated_at",
    "deleted_at",
  ];

  for (let atr of valuesToDelete) {
    delete values[atr];
  }
  return values;
};

//Upload .Xlsx .csv file Data
//  bulk import
export function productBulkImport(file) {
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  let formData = new FormData();
  formData.append("file", file);
  return axios.post(`${PRODUCT_URL}/import-products`, formData, {
    headers: headers,
  });
}

// CHECK IMPORT STATUS
export function checkImportApiStatus(id) {
  return checkBackgroundTaskStatus(id);
}

export function productBulkCreate(params) {
  return axios.post(`${PRODUCT_URL}/v3/import`, params);
}

export function productBulkCreatePrices(params) {
  return axios.post(`${PRODUCT_URL}/v3/import/prices`, params);
}

export function newproductsImport(params) {
  return axios.post(`${PRODUCT_URL}/import/new-products-from-excel`, params);
}

export function updateProductThroughPatch(id, payload) {
  return axios.patch(`${PRODUCT_URL}/${id}`, payload);
}

export function productDiscription(params) {
  return axios.post(`${CHATGPT_DISCRIP_URL}`, params);
}

// EXPORT PRODUCTS
export function checkExportApiStatus(params, queryParams = {}) {
  return axios.post(`${PRODUCT_REPORT}?${productQueryParamsToStr(queryParams)}`, params);
}

export function checkPriceExportApi(payload, queryParams = {}) {
  return axios.post(`${PRODUCT_URL}/v3/export/prices?${productQueryParamsToStr(queryParams, true)}`, payload);
}

export function checkBulkCreateTemplateExportApi() {
  return axios.post(`${PRODUCT_URL}/export/new-products-from-excel/template`);
}
export function getProductById(productId) {
  return axios.get(`${PRODUCT_URL}/${productId}`);
}

export function getProductDetails(productId, include_customr_group_prices) {
  return axios.get(`${PRODUCT_URL}/${productId}?include_customer_group_prices=${include_customr_group_prices ? 1 : 0}`);
}

export function getProductByIdViaList2(productId, channel = 1) {
  return axios.get(`${PRODUCT_URL}/list2?product_ids=${productId}&channel_id=${channel}`);
}
export function getManufacturer(params) {
  return axios.get(`${MANUFACTURER_URL}/list`, { params });
}

export function getManufacturerbyID(id) {
  return axios.get(`${MANUFACTURER_URL}/${id}`);
}

export function saveManufacturer(payload) {
  return axios.post(MANUFACTURER_URL, payload);
}

export function editManufacturer(id, payload) {
  return axios.put(`${MANUFACTURER_URL}/${id}`, payload);
}

export function postPurchaseOrderOCRLabels(productInfo) {
  const url = `${basepath}/catalog/products/${productInfo.id}/alias`;
  const data = {
    //   item_id: productInfo.id,
    alias: productInfo.desc, // assuming desc is the correct property name
  };
  return axios.post(url, data);
}

export function productQueryParamsToStr(queryParams, isEncodedSearch = false) {
  const {
    name,
    search_key,
    pageNumber,
    pageSize,
    sortField,
    sortOrder,
    categories,
    channel_id,
    suppliers,
    min_price,
    max_price,
    is_msa_compliant,
    filter_by_image,
    location_ids,
    is_online,
    is_featured,
    is_hot_seller,
    is_promotion,
    is_new_arrival,
    statuses,
    is_archived,
    scan_mode,
    brand_ids,
    showVariant,
    show_default,
    promotion_status,
    include_categories,
    include_tags,
    include_suppliers,
    is_tax_applicable,
    expiry_start_date,
    expiry_end_date,
    msa_category_ids,
    vg_ids,
    tag_ids,
  } = queryParams;
  return `name=${name || ""}&page=${pageNumber || initialFilter.pageNumber}&page_size=${pageSize || 20}&sort_by=${sortField || initialFilter?.sortField}:${
    sortOrder || initialFilter?.sortOrder
  }&category_ids=${categories || ""}&channel_id=${channel_id || 1}&supplier_ids=${suppliers || ""}&min_price=${
    min_price ? min_price : ""
  }&max_price=${max_price ? max_price : ""}&is_msa_compliant=${
    is_msa_compliant || ""
  }&filter_by_image=${filter_by_image || 0}&is_online=${is_online || ""}&is_featured=${is_featured || ""}&is_hot_seller=${is_hot_seller || ""}&is_promotion=${is_promotion || ""}&is_new_arrival=${is_new_arrival ? is_new_arrival : ""}&statuses=${
    statuses || ""
  }&is_archived=${is_archived ?? ""}&scan_mode=${scan_mode || 0}&brand_ids=${brand_ids || ""}&vg_ids=${vg_ids || ""}&tag_ids=${Array.isArray(tag_ids) ? tag_ids.join(",") : tag_ids || ""}&promotion_status=${promotion_status || ""}${
    showVariant ? `&is_default_variant=${showVariant || ""}` : ""
  }&show_default=${show_default || ""}&include_categories=${include_categories || 0}&include_suppliers=${include_suppliers || 0}&include_tags=${include_tags || 0}&search_key=${search_key ? (isEncodedSearch ? encodeURIComponent(search_key) : search_key) : ""}&is_tax_applicable=${is_tax_applicable === 3 ? "" : is_tax_applicable ?? ""}&msa_category_ids=${
    msa_category_ids || ""
  }&expiry_start_date=${expiry_start_date || ""}&expiry_end_date=${expiry_end_date || ""}&location_ids=${location_ids || ""}&show_stocks=1`;
}
// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findProducts(queryParams) {
  queryParams = queryParams === undefined ? initialFilter : queryParams;
  const queryParamsStr = productQueryParamsToStr(queryParams);
  return axios.get(`${PRODUCT_URL}/list3?${queryParamsStr}`);
  // &show_last_sold=1&show_last_purchased=1&include_categories=1 it make query very slow
}

export function findProductsByBrandId(brandId, extraParams = {}) {
  if (!brandId) {
    return Promise.resolve({ data: { totalCount: 0, entities: [] } });
  }
  return findProducts({
    pageNumber: 1,
    pageSize: 20,
    channel_id: 1,
    is_archived: 0,
    brand_ids: brandId,
    show_default: "",
    include_categories: 0,
    include_suppliers: 0,
    ...extraParams,
  });
}

export function productsWithCueTip(params) {
  return axios.post(PRODUCT_CUETIP_URL, params);
}
export function saveVariants(payload) {
  return axios.post(PRODUCT_VARIANT, payload);
}
export function editSpecificVariants(id, payload) {
  return axios.put(`${PRODUCT_VARIANT}/${id}`, payload);
}
export function getVariants(id) {
  return axios.get(`${PRODUCT_VARIANT}/${id}`);
}
export function findVariantGroups(params) {
  return axios.get(`${PRODUCT_VARIANT}/list`, { params });
}
export function findOptimizedProducts(params) {
  return axios.get(`${PRODUCT_URL}/list3`, { params });
}
export function findCategoryProducts(params) {
  return axios.get(`${PRODUCT_URL}/list3`, { params });
}

export function getTaxAttributeList(id) {
  return axios.get(`${PRODUCT_URL}/${id}/tax-attribute/list`);
}

export function getTaxList(id) {
  return axios.get(`${PRODUCT_URL}/${id}/tax/list`);
}

export function addProductTax({ id, tax_id, tax_class_id }) {
  return axios.post(`${PRODUCT_URL}/${id}/tax/${tax_id}`, { tax_class_id });
}

export function updateProductTax({ id, tax_id, tax_class_id }) {
  return axios.put(`${PRODUCT_URL}/${id}/tax/${tax_id}`, { tax_class_id });
}

export function deleteProductTax(pro_id, tax_id) {
  return axios.delete(`${PRODUCT_URL}/${pro_id}/tax/${tax_id}`);
}

export function updateAttributeValuesList(id, payload) {
  return axios.put(`${PRODUCT_URL}/${id}/tax-attribute`, payload);
}

export function delVariants(id) {
  return axios.delete(`${PRODUCT_VARIANT}/${id}`);
}

export function findAttributes(queryParams) {
  return axios.get(`${CATEGORY_URL}/attributes`, {
    params: queryParams,
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
}

// UPDATE => PUT: update the product on the server
export function updateProduct(product) {
  productMedia.videoData = product.video;
  productMedia.imagesData = product.images;
  product = deleteExtraEntries(product);
  let id = product.id;
  delete product.id;
  return axios.put(`${PRODUCT_URL}/${id}`, JSON.stringify(product).replace(/\:null/gi, ":null"));
}

// DELETE => delete the product from the server
export function deleteProduct(productId) {
  return axios.delete(`${PRODUCT_URL}/${productId}`);
}
// RESTORE => restore the archive product from the server
export function restoreProducts(ids) {
  // list of ids of products to restore the products
  return axios.patch(`${PRODUCT_URL}/bulk`, [...ids]);
}
export function productBulkStatusUpdate(productinfo) {
  return axios.patch(`${PRODUCT_URL}/bulk`, productinfo);
}
export function productStatusUpdate(productinfo) {
  return axios.patch(`${PRODUCT_URL}/bulk`, [{ ...productinfo }]);
}
// DELETE Products by ids
export function deleteProducts(ids) {
  return axios.delete(`${PRODUCT_URL}/bulk`, { data: ids });
}

export function fetchSKU(params) {
  return axios.get(`${PRODUCT_URL}/generate-sku`, { params });
}
export function generateUPC() {
  return axios.get(`${PRODUCT_URL}/generate-upc`);
}
export function importLocations() {
  return axios.get(`${PRODUCT_URL}/import/locations`);
}

export function getPresignedUrl(key) {
  key = key.replaceAll(" ", "-");
  return axios.post(PRESIGNED_URL, [{ key: key }]);
}
export function uploadPdfFileToCloud(payload, url = "") {
  return new Promise((resolve, reject) => {
    axios
      .post(`${basepath + url}`, { key: payload })
      .then((response) => {
        if (response?.data?.id) {
          localStorage.setItem("ocrPdfComplingId", response.data.id);
          genericStatusChecker("ocrPdfComplingId", checkImportApiStatus, reject, resolve);
        }
      })
      .catch((error) => {
        reject(error); // Reject the Promise with the error
      });
  });
}

export function getPresignedUrlCategory(image) {
  return axios.post(PRESIGNED_URL, [{ key: image }]);
}

export function uploadFileToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}

export function uploadFileToCloudCategory(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}

export function getImage(upc) {
  return axios.post(UPC_URL, upc);
}
export function isUPCExist(upc) {
  return axios.post(UPC_CHECK_URL, { product_upc: upc });
}

// Custom Pages Banner Image
export function getPresignedUrlForBanner(image) {
  return axios.post(PRESIGNED_URL, [{ key: image }]);
}

export function uploadFileToCloudBanner(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}

export function applyBulkActions(payload) {
  return axios.post(BULK_UPDATE_URL, payload);
}

export function exportProductLable(payload) {
  return axios.post(EXPORT_LABEL_URL, payload);
}

// Unused in-store UPCs, offered without being saved.
export function suggestProductUpcs(count) {
  return axios.get(GENERATE_UPC_URL, { params: { count } });
}

// Generates in-store UPCs (from the SKU where it has digits) and saves them on
// the given unit prices. `replace` overwrites a UPC the unit already has.
export function generateProductUpcs(unitPriceIds, replace = false) {
  return axios.post(GENERATE_UPC_URL, { unit_price_ids: unitPriceIds, replace });
}

export function findPromotions(queryParams) {
  return axios.get(
    `${PROMOTIONS_URL}/list?search_key=${queryParams?.searchKey || ""}&statuses=${queryParams?.statuses || ""}&page=${
      queryParams.pageNumber || 1
    }&product_ids=${queryParams?.productIds || ""}&page_size=${queryParams.pageSize || 20}&sort_by=${queryParams.sort_by || "created_at:desc"}`
  );
}

// Get Product Activity Logs
export function productLogs(queryparams) {
  return axios.get(`${ACTIVITY_LOGS_NEW}?table_name=products&entity_id=${queryparams?.product_id}&sort_by=created_at:desc`);
}

export function resetPreservePrice(payload) {
  const { id, units, channel_ids } = payload;
  return axios.put(`${PRODUCT_URL}/${id}/preserved-price/reset`, { units, channel_ids });
}

export function checkProductLogsExport(product_id, savedValues) {
  return axios.post(
    `${PRODUCT_LOGS_EXPORT_URL}?entity_id=${product_id}&start_date=${savedValues.start_date}&end_date=${savedValues.end_date}&channel_ids=${savedValues.channel_ids}`
  );
}

export function productBulkUpdateInOCR(payload) {
  return axios.post(`${PRODUCT_URL}/ocr-info-to-products`, payload);
}

export function getProductLabels(productId) {
  return axios.get(`${PRODUCT_URL}/${productId}/labels`);
}

export function updateProductLabels(productId, tagIds) {
  return axios.put(`${PRODUCT_URL}/${productId}/labels`, { tag_ids: tagIds });
}
